import TagButton from './TagButton';


const Navbar = ({ tags, activeTag, onTagChange }) => {
  return (
    <div className="flex flex-wrap sm:gap-4 gap-2 items-center justify-center">
      {tags.map((tag, index) => (
        <TagButton
          key={tag}
          label={tag}
          isActive={tag === activeTag}
          onClick={() => onTagChange(tag, index)}
        />
      ))}
    </div>
  );
};

export default Navbar;
